import ExampleCodeBlock from 'components/Docs/ExampleCodeBlock'

const npm = `npm install @integration-app/sdk`

export function InstallSdkCodeExample() {
  return <ExampleCodeBlock customCodes={{ npm }} />
}
